import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'directory-base-v3.table-cells.favourite-cell.title',
		defaultMessage: 'Something’s gone wrong',
		description: 'Title explaining that there was an error',
	},
	description: {
		id: 'directory-base-v3.table-cells.favourite-cell.description',
		defaultMessage: 'You cannot star items right now due to an error.',
		description:
			'Text to describe that there was an error trying to perform an action with the server (e.g. starring or unstarring an item)',
	},
});
